import React from 'react';

import { MarkRoot } from './mark.styled';

const Mark: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <MarkRoot component="span">{children}</MarkRoot>
);

export default Mark;
